import React from 'react';
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'connected-react-router';
import history from './utils/history';
import { ToastContainer } from 'react-toastify';
import configureStore from './store/configureStore';
import Navigation from './navigation'
import './App.css';


// Create redux store with history

const initialState = {};
const { store } = configureStore(initialState, history);

const App = () => {
  return (
    <Provider store={store}>
      <ToastContainer />
      <ConnectedRouter history={history}>
        <Navigation />
      </ConnectedRouter>
    </Provider>
  );
}

export default App;
